import { format, parse, isValid } from 'date-fns';

// if inputDate is valid with particular input format then it will format date else it will go to continue to check for next format. If no possible format is valid with input date then this function will return inputDate.

function dateFormat(inputDate: string, dateFormats: { [key: string]: string }) {
  const { finalDateFormat } = dateFormats;
  const possibleFormats = [
    'yyyy-MM-dd', // 2025-01-15
    'MM-dd-yyyy', // 01-15-2025
    'dd-MM-yyyy', // 15-01-2025
    'dd-M-yyyy', // 15-1-2025

    //not needed but possible formats.
    // 'yyyy-M-d', // 2025-1-15
    // 'yy-MM-dd', // 25-01-15
    // 'yy-M-d', // 25-1-15

    // 'M-d-yyyy', // 1-15-2025
    // 'MM-dd-yy', // 01-15-25
    // 'M-d-yy', // 1-15-25

    // 'd-M-yyyy', // 15-1-2025
    // 'dd-MM-yy', // 15-01-25
    // 'd-M-yy', // 15-1-25
  ];

  for (const inputFormat of possibleFormats) {
    try {
      const parsedDate = parse(inputDate, inputFormat, new Date());
      if (isValid(parsedDate)) {
        return format(parsedDate, finalDateFormat);
      }
    } catch (error) {
      continue;
    }
  }
  return inputDate;
}

export default dateFormat;
